import { cn } from '@zealot/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

// gloss
const textareaVariants = cva(
  'field-sizing-content flex min-h-16 w-full resize-none border border-input bg-field outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
  {
    variants: {
      size: {
        sm: 'rounded-md px-2 py-1.5 text-xs/relaxed',
        default: 'rounded-md px-2 py-2 text-sm md:text-xs/relaxed',
        lg: 'rounded-lg px-3 py-2 text-sm',
      },
    },
    defaultVariants: { size: 'default' },
  },
);

type TextareaProps = Omit<React.ComponentProps<'textarea'>, 'size'> & VariantProps<typeof textareaVariants>;

const Textarea = ({ className, size = 'default', ...props }: TextareaProps) => {
  return <textarea data-slot="textarea" className={cn(textareaVariants({ size, className }))} {...props} />;
};

export type { TextareaProps };
export { Textarea, textareaVariants };
